// extracted by mini-css-extract-plugin
export default {"component-microsite-menu":"component-microsite-menu_kj7nO","componentMicrositeMenu":"component-microsite-menu_kj7nO"};